import React from 'react';
import { useQuery } from '@tanstack/react-query';
// import { ICartItem } from '@/types/ICart';
// import { IUser } from '@/types/IUser';
import { calculateRedemptionValue } from '../../utils/calculateRedemptionValue';
import styles from './PinsDisplay.module.css';
import ShareActions, { DealActions } from '../../components/shareActions/ShareActions';
import {
  sendPinSmsMessage,
  sendTopUpSmsMessage,
  sendPinWhatsAppMessage,
  sendTopUpWhatsAppMessage,
  sendPinEmailMessage,
  sendTopUpEmailMessage,
} from '../../utils/sendPins';

// interface IPinDisplayProps {
//   transactionId?: string;
//   item: ICartItem;
//   user: IUser;
// }

// interface IPinVoucher {
//   vouchers: { pin: string; status?: { message: string } }[];
//   retrievedPinData: any;
//   isLoading: boolean;
//   isError: boolean;
// }

const fetchPin = async (transactionId) => {
  const response = await fetch(
    `${process.env.REACT_APP_API_VOUCHERS_URL}/dtone-transaction-query?transactionId=${transactionId}`,
  );
  if (!response.ok) {
    throw new Error('Failed to fetch pin');
  }
  const data = await response.json();
  return data;
};

const VoucherList = ({ vouchers, retrievedPinData, isLoading, isError }) => {
  if (isError) return <div>Failed to load</div>;

  const status = isLoading ? 'LOADING...' : retrievedPinData[0]?.status?.message;
  const pin = isLoading ? 'LOADING...' : retrievedPinData[0]?.pin?.code;

  if (status === 'DECLINED') return <p style={{ fontSize: '1rem' }}>Status: {status}</p>;

  return (
    <>
      {vouchers &&
        vouchers.length > 0 &&
        vouchers.map((voucher, index) => (
          <>
            {/* {voucher?.status?.message && (
            <p key={index} style={{ fontSize: '28px' }}>
              <strong>STATUS: {voucher?.status?.message}</strong>
            </p>
          )} */}
            {/* {voucher[0]?.pin?.status?.message ? (
            <div key={index}>
              <strong>STATUS: {voucher[0]?.pin?.status?.message}</strong>
            </div>
          ) : null} */}
            {isLoading ? (
              <p key={index} style={{ fontSize: '28px' }}>
                {status}
              </p>
            ) : (
              <p key={index} style={{ fontSize: '28px' }}>
                {/* <strong>PIN: {voucher?.pin ?? '---'}</strong> */}
                <strong>PIN: {voucher?.pin ?? pin ?? 'Not available'}</strong>
              </p>
            )}
          </>
        ))}
    </>
  );
};

export const formatUsdAmount = (totalAmountTendered) => {
  if (!totalAmountTendered) {
    return '-';
  }

  try {
    // Handle case where it's already a number
    if (typeof totalAmountTendered === 'number') {
      return totalAmountTendered.toFixed(2);
    }

    // Handle case where it's a string with "USD" prefix
    if (typeof totalAmountTendered === 'string' && totalAmountTendered.includes(' ')) {
      const usdAmount = Number(totalAmountTendered.split(' ')[1]).toFixed(2);
      return usdAmount;
    }

    // Handle case where it's just a string number
    return Number(totalAmountTendered).toFixed(2);
  } catch (error) {
    console.log('Error formatting USD amount:', error);
    return '-';
  }
};

export const VoucherListZesa = ({ vouchers, productRecipient }) => {
  let recipientName = '';
  let recipientAddress = '';
  let electricityCurrency = '';

  // Get electricity customer data from productRecipient if available
  if (productRecipient && productRecipient.electricityCustomerData) {
    recipientName = productRecipient.electricityCustomerData.split('\n')[0];
    recipientAddress = productRecipient.electricityCustomerData.split('\n')[1];
    electricityCurrency = productRecipient.electricityCurrency;
  } else if (vouchers) {
    try {
      // Check if vouchers is an array, and get the first item if it is
      const firstVoucher = Array.isArray(vouchers) ? vouchers[0] : vouchers;

      // Try to extract electricity currency from the first voucher's energy property
      if (firstVoucher && firstVoucher.details && firstVoucher.details.energy) {
        electricityCurrency = firstVoucher.details.energy.substring(0, 3);
      }
    } catch (error) {
      console.log('Error parsing electricity currency:', error);
      electricityCurrency = '';
    }
  }

  if (!vouchers) {
    return <p>No voucher data available</p>;
  }

  // Handle both single voucher and array of vouchers
  const vouchersArray = Array.isArray(vouchers) ? vouchers : [vouchers];

  return (
    <>
      {vouchersArray.length > 0 ? (
        vouchersArray.map((voucher, index) => (
          <div key={index} style={{ fontSize: '1rem' }}>
            <p style={{ fontSize: '24px' }}>
              <strong>Token: {voucher?.pin ?? 'Not available'}</strong>
            </p>
            <p>
              <strong>Meter number: {voucher?.details?.meter ?? 'Not available'}</strong>
            </p>
            {recipientName && recipientAddress && (
              <>
                <p>
                  <strong>Name: {recipientName ?? 'Not available'}</strong>
                </p>
                <p>
                  <strong>Address: {recipientAddress ?? 'Not available'}</strong>
                </p>
              </>
            )}
            <p>KWH: {voucher?.details?.kwh ?? 'Not available'}</p>
            <p>Energy: {voucher?.details?.energy ?? 'Not available'}</p>
            <p>Debt: {voucher?.details?.debt ?? 'Not available'}</p>
            <p>REA: {voucher?.details?.rea ?? 'Not available'}</p>
            <p>VAT: {voucher?.details?.vat ?? 'Not available'}</p>
            {electricityCurrency && <p>Meter Currency: {electricityCurrency ?? 'Not available'}</p>}
            <p>Total amount: {voucher?.details?.totalAmount ?? 'Not available'}</p>
            <p>Total amount tendered: {`USD ${formatUsdAmount(voucher?.details?.totalAmountTendered)}`}</p>
            <p>Reference ID: {voucher?.details?.referenceId ?? 'Not available'}</p>
            <p>Date: {voucher?.details?.date ?? 'Not available'}</p>
          </div>
        ))
      ) : (
        <p>No voucher details available</p>
      )}
    </>
  );
};

const PinsDisplay = ({ item, user, transactionId = '' }) => {
  const {
    data: retrievedPinData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ['fetch-pin_dtone', transactionId],
    queryFn: () => fetchPin(transactionId),
    enabled: item?.vouchers && !item?.vouchers[0]?.pin,
    retry: 5,
    retryDelay: 5000,
  });

  return (
    <div key={item.deal.dealId} className={styles.voucherContainer}>
      {item.quantity} x {item.deal.voucherName} voucher at {item.deal.merchantName}
      <br />
      <br />
      <div className={styles.purchaseDetails}>
        Value: {item.deal.redemptionCurrency} {calculateRedemptionValue(item).toFixed(2)}
        {item.deliveryFee ? (
          <>
            <br />
            Delivery Fee: {item.deal.redemptionCurrency} {item.deliveryFee.toFixed(2)}
            <br />
            <br />
          </>
        ) : (
          item.deal.partnerName === 'Crossroads' &&
          (item.deliveryFee === 0 || !item.deliveryFee) && (
            <>
              <br />
              Collection at Crossroads, contact{' '}
              <a href="https://wa.me/message/QP6XXOK3HUQTE1" target="_blank">
                on WhatsApp
              </a>
              .<br />
              <br />
            </>
          )
        )}
      </div>
      {item?.vouchers && item?.vouchers?.length > 0 ? (
        <VoucherList
          vouchers={item?.vouchers}
          retrievedPinData={retrievedPinData ?? []}
          isLoading={isLoading}
          isError={isError}
        />
      ) : (
        <p>No vouchers to display.</p>
      )}
      <br /> <br />
      {item.productRecipient && item.productRecipient.name && user && (
        <ShareActions
          recipientName={item.productRecipient.name}
          item={item}
          user={user}
          sendWhatsAppMessage={sendPinWhatsAppMessage}
          sendEmailMessage={sendPinEmailMessage}
          sendSmsMessage={sendPinSmsMessage}
        />
      )}
    </div>
  );
};

const PinsDisplayZesa = ({ item, user }) => {
  return (
    <div key={item?.deal?.dealId} className={styles.voucherContainer}>
      {item?.quantity} x {item?.deal?.voucherName} voucher at {item?.deal?.merchantName}
      <br />
      <br />
      {item?.vouchers && item?.vouchers?.length > 0 && item?.vouchers[0] ? (
        <VoucherListZesa vouchers={item.vouchers[0]} productRecipient={item.productRecipient || {}} />
      ) : (
        <p>No vouchers to display.</p>
      )}
      <br /> <br />
      {item?.productRecipient && item?.productRecipient?.name && user && (
        <ShareActions
          recipientName={item.productRecipient.name}
          item={item}
          user={user}
          sendWhatsAppMessage={sendPinWhatsAppMessage}
          sendEmailMessage={sendPinEmailMessage}
          sendSmsMessage={sendPinSmsMessage}
        />
      )}
    </div>
  );
};

const TopUpsDisplay = ({ item }) => {
  return (
    <div key={item.deal.dealId} className={styles.voucherContainer}>
      {item.quantity} x {item.deal.redemptionCurrency} {calculateRedemptionValue(item).toFixed(2)}{' '}
      {item.deal.voucherName} was topped-up
      {item.productRecipient && item.productRecipient.mobileNumber && (
        <>
          {' '}
          to <strong>{item.productRecipient.mobileNumber}</strong>
        </>
      )}
      .
      <br /> <br />
      {/* {item.productRecipient && recipientName && user && (
        <ShareActions
          recipientName={recipientName}
          item={item}
          user={user}
          sendWhatsAppMessage={sendTopUpWhatsAppMessage}
          sendEmailMessage={sendTopUpEmailMessage}
          sendSmsMessage={sendTopUpSmsMessage}
        />
      )} */}
    </div>
  );
};

const DonationsDisplay = ({ item, user }) => {
  return (
    <div key={item.deal.dealId} style={{ marginBottom: '50px', padding: '2rem' }}>
      Your donation of {item.quantity} x {item.deal.redemptionCurrency} {calculateRedemptionValue(item).toFixed(2)}{' '}
      {item.deal.voucherName} is being sent over to {item.deal.merchantName}.
      <br />
      <br />
      <DealActions
        redemptionInstructions={item.deal.redemptionInstructions}
        voucherDescription={item.deal.voucherDescription}
        terms={item.deal.terms}
        productName={item.deal.voucherName}
      />
    </div>
  );
};

export { PinsDisplay, TopUpsDisplay, DonationsDisplay, PinsDisplayZesa };
